import { queryCollectionOptions } from "@tanstack/query-db-collection";
import {
    collectionOptions,
    type DbClient,
    type LiveQueryOptions,
} from "@tanstack/react-db";
import type { QueryClient } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";
import { getCatalog } from "@/lib/core/catalog-core.server";
import { BreedDirectorySchema } from "./breed.contract";

const getAllBreeds = createServerFn({ method: "POST" }).handler(async () => {
    const catalog = await getCatalog();
    try {
        return BreedDirectorySchema.parse(await catalog.breeds.getAllBreeds());
    } catch (error) {
        if (!(error instanceof Error) || !(error.cause instanceof Error)) {
            throw error;
        }
        throw new Error(`${error.message}\ncause: ${error.cause.message}`, {
            cause: error.cause,
        });
    }
});

export const breedsCollection = collectionOptions("breeds", (dbClient) =>
    queryCollectionOptions({
        id: "breeds",
        queryKey: ["breeds"],
        queryClient: dbClient.requireDependency<QueryClient>("queryClient"),
        getKey: (item) => item.id,
        queryFn: async () => {
            return await getAllBreeds();
        },
    }),
);

export const breedsLiveQueryOptions = {
    queryKey: ["breeds"],
    query: (query) => query.from({ breedsCollection }),
} satisfies LiveQueryOptions;

export async function preloadBreeds(dbClient: DbClient) {
    await dbClient.preloadLiveQuery(breedsLiveQueryOptions);
}
